<template>
  <div class="About">
    <!-- 第一张图片 -->
    <div class="firstImg">
      <transition-group name="fade" tag="div">
        <div v-for="header in headers" :key="header.id" v-show="header.id === currentId">
          <h1>{{ header.text}}</h1>
        </div>
      </transition-group>
      <img src="@/img/DSC_0655.png">
      <div class="mengban"></div>
    </div>
    <!-- 关于意达 -->
    <div class="aboutEda">
      <h6>关于意达</h6>
      <div class="content">
        <p>深圳市意达五金制品有限公司成立于2009年，初创地址：深圳市光明新区公明街道上村社区莲塘工业城B区第22栋A单元
           经营项目：五金件、塑胶件、五金模具、塑胶模具的研发、生产与销售。
        </p>
        <p>深圳市意达五金制品有限公司注重建立诚信和透明的工作环境。管理层与员工之间的沟通是开放的，关于公司的目标、决策以及业绩情况的信息被积极分享。
          鼓励员工提出新的创意和解决方案，并有机会参与企业各大创新项目，同时企业还会提供资源进行培训提升员工的能力与创造性思维。</p>
          <p class="smain">员工发展：员工的培训和发展被公司重视。公司提供持续学习机会，包括导师计划和晋升机会，以帮助员工提高技能和职业发展。</p>
          <p class="smain">多元和包容：公司鼓励多元化和包容性，确保每个员工都受到平等对待和尊重，无论其种族、性别或文化背景如何。</p>
          <p class="smain">团队协作：公司倡导团队协作，鼓励员工共同合作，分享想法，解决问题，以提高工作效率。</p>
          <p class="smain">社会和环境责任：公司积极履行社会和环境责任，参与可持续性倡议，并支持员工参与慈善和志愿者活动。</p>
          <p class="smain">灵活的工作环境：公司理解员工的需求，提供灵活的工作安排，包括远程工作和弹性工作时间，以帮助员工更好地平衡工作与生活。</p>
          <p class="smain">奖励和认可：公司建立了公平的奖励和认可制度，以表彰员工的卓越表现和贡献。</p>
      </div>
    </div>
    <div class="aboutEda2_box">
      <div class="aboutEda2">
      <div class="Eda2_box Eda2_left">
        <img src="@/img/team.jpg">
      </div>
      <div class="Eda2_right Eda2_box">
        <div class="Eda2_text">
          <p >意达始终坚持“以人为本”，这不仅是我们的企业理念，更是我们文化的核心。在意达，我们相信每一位员工都是企业最宝贵的财富，他们是我们成功的关键。</p>
          <p >在这里，我们倡导团队合作，鼓励员工分享想法和经验，互相支持，共同成长。我们重视员工的个人发展，提供专业的培训和培养机会，帮助他们不断提升自我，实现职业目标。</p>
          <p >我们关心员工的生活品质，提供完善的福利制度和人性化的关怀服务，让员工工作愉快，生活幸福。</p>
          <p >“以人为本”是我们实践的承诺。意达将继续秉承这一理念，为员工创造更美好的工作环境和未来发展机会，共同书写企业和员工成功的华美篇章。</p>
        </div>
      </div>
    </div>
    </div>
    <!-- 核心价值观 -->
    <div class="values">
      <h1>核心价值观</h1>
      <div class="value_contents">
        <div v-for="value in values" :key="value.id" class="value_content" :class="value.img">
          <h2>{{ value.title }}</h2>
          <p>{{ value.text1 }}<br>{{ value.text2 }}</p>
        </div>
      </div>
    </div>
    <!-- 理念 -->
    <div class="linian">
      <div class="linian_contents">
        <div class="linian_left linian_content">
          <h1>核心理念</h1>
          <span>意达五金始终坚持客户至上的理念<br>积极致力于提高客户满意度<br>不断创新和提升</span>
        </div>
        <div class="linian_right linian_content">
          <img src="@/img/kehu2.jpg">
        </div>
      </div>
    </div>
    <!-- 箭头 -->
    <div class="jiantous">
      <h1 class="jiantou">
        联系我们
      </h1>
      <div class="icon jiantou ">
        <!-- pulse -->
        <Icon  type="jiantou_xia" class="icon_main animate__animated animate__bounce animate__infinite animate__slower"></Icon>
      </div>
    </div>
    <!-- 地图 -->
    <div class="ditus">
      <div class="ditu_left ditu">
        <img src="@/img/ditu.png" alt="">
      </div>
      <div class="ditu_right ditu">
        <h1>深圳市意达五金制品有限公司</h1>
        <span>TEL：13824352916</span><br>
        <span>E-mail：EDAMOLD@163.com</span><br>
        <span>ADD：广东省深圳市光明区光明区公明上村莲塘工业城B区第22栋A单元</span><br>
        <span>占地面积：5000平方米</span><br>
        <span>成立时间：2009年7月</span><br>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon';
export default {
  
  components:{
    Icon,
  },
  data() {
    return {
      // 所有头部信息的数组和当前显示的头部id
      headers: [
        { id: 1, text: '每一个清晨，都是一个新的开始' },
        { id: 2, text: '我们如日出般稳定' },
        { id: 3, text: '经得起时间的考验，宛如云海，高居行业之巅！' },
        { id: 4, text: '勇攀高峰，与您共同见证这宏伟与辉煌' },
        { id: 5, text: '千里之行，始于足下！' }
      ],
      values:[
        {id:1, title:'品质至上', text1:'坚持精益求精的原则',text2:'追求卓越的品质和工艺标准',img:'pinzhi'},
        {id:2, title:'创新驱动', text1:'积极引入新技术、新方法和新理念',text2:'推动企业持续发展以及提升企业核心竞争力',img:'chuangxin'},
        {id:3, title:'团结协作', text1:'我们珍视团队合作的重要性',text2:'倡导员工之间的互相支持和协作',img:'tuanjie'},
      ],
      currentId: 1, // 当前显示的头部的id
    }
  },
  mounted() {
    // 当组件挂载后，开始循环显示头部
    this.startHeaderLoop();
  },
  methods:{
    //开始头部文字循环显示
    startHeaderLoop() {
      setInterval(() => {
        // 每次调用将currentId增加1，如果超过5则从1开始
        // this.currentId = this.currentId === 5 ? 1 : this.currentId + 1;
        this.currentId=this.currentId === 5 ? 1 : this.currentId +1;
      }, 3000); // 每5秒切换一个header
    }
    //设置图片
  }

}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
img{
  border-radius:10px;
}
/* 第一张图片 */
.firstImg{
  position: relative;
  font-size: 0px;
  min-width:1500px;
}
.firstImg img{
  width: 100%;
  min-width:1500px;
  height: 100%;
  object-fit:cover;
}
.mengban{
  min-width:1500px;
  top:0;
  z-index: 1;
  background: linear-gradient(to bottom, rgba(150,150,150,0.3), rgba(255,255,255,0));
  position: absolute;
  width: 100%;
  height: 50%;
}
/* 文字样式 */
.firstImg h1{
  /* min-width:1500px; */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  color: #fff;
  opacity: 1;
  font-weight: 400;
  /* 调整字间间隙 */
  letter-spacing: 10px;
  user-select: none;
  font-size: 25px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

/* 关于意达模块 */
.aboutEda{
  border-top: 2px solid rgba(33, 85, 176,0.5);
  border-bottom: 2px solid rgba(33, 85, 176,0.5);
  width: 1200px;
  min-width:1500px;
  display: flex;
  flex-direction:column;
  letter-spacing: 7px;
  margin: 100px auto;
  align-items:center;
  padding: 100px 250px;
}
.aboutEda h6{
  width: 1200px;
  font-weight: 250;
  font-size: 50px;
  margin-bottom: 30px;
  padding: 0 auto;
  text-align:center;
  color: #555;
}
.aboutEda p{
  text-indent: 2em;
  line-height: 1.75em;
  margin-bottom: 18px;
  font-size:16px;
  color: rgb(109, 127, 156);
}
/* 关于意达2 */
.aboutEda2_box{
  min-width:1500px;
  background: rgb(251, 251, 251);
  margin: 200px auto;
}
.aboutEda2{
  display: flex;
  color: rgb(109, 127, 156);
  margin: 0 auto;
  margin-bottom: 100px;
  width: 1500px;
}
.Eda2_box{
  flex: 1;
}
.Eda2_left{
  text-align: right;
}
.aboutEda2 img{
  width: 650px;
}
.Eda2_right{
  text-indent: 2em;
  line-height: 1.75em;
  padding-top: 2%;
}
.Eda2_text{
  padding: 0 15%;
}
.Eda2_text p{
  margin: 10px 0;
}
/* 核心价值观模块 */
.values{
  width: 100%;
  min-width:1500px;
  margin: 200px auto;
  padding: 0;
  border-top: 2px solid rgba(33, 85, 176,0.5);
}
.values h1{
  text-align:center;
  font-weight: 530;
  padding: 30px 0;
  margin-bottom: 50px;
  font-size:40px;
}
.value_contents{
  display: flex;
  justify-content:flex-start;
  flex-direction:row;
}
.value_content{
  flex:1;
  text-align:center;
  padding-top: 4%;
  padding-bottom: 3%;
}
.value_content h2{
  padding: 10px;
  font-weight: 450;
}
.value_content p{
  line-height: 2.4em;
  padding: 50px;
}

.pinzhi{
  background: url(../../img/pinzhi.png);
  background-repeat:no-repeat;
  background-size:cover;
  background-position: center center
}
.chuangxin{
  background: url(../../img/chuangxin.png);
  background-repeat:no-repeat;
  background-size:cover;
  background-position: center center
}
.tuanjie{
  background: url(../../img/tuandui.png);
  background-repeat:no-repeat;
  background-size:cover;
  background-position: center center
}
/* 理念模块 */
.linian{
  margin-top: 200px;
  margin-bottom: 200px;
  min-width:1500px;
  background-color:rgb(251, 251, 251);
}
.linian_contents{
  display: flex;
}
.linian_content{
  flex: 1;
}
.linian_left{
  font-size: 26px;
  font-weight: 300;
  text-align: center;
  padding: 40px 0;
  line-height: 2.5em;
}
.linian_left h1{
  color: rgb(109, 127, 156);
}
.linian_right img{
  object-fit: cover;
}
/* 箭头板块 */
.jiantous{
  margin-top: 200px;
  min-width:1500px;
  text-align: center;
}

.jiantou{
  color: #555;
  font-weight: 500;
}
.icon{
  margin: 23px;
}
.icon_main{
  display: block;
  width: 200px;
  margin:0 auto;
  opacity: 0.5;
}
.iconfont{
  font-size: 100px;
}
/* 地图模块 */
.ditus{
  margin: 200px 0;
  min-width:1500px;
  display: flex;
  background: rgb(251, 251, 251);
}
.ditu{
  flex: 1;
}
.ditu_left{
  padding: 50px 0;
  text-align: right; 
}
.ditu_left img{
  width: 600px;
  box-shadow:0 0 2px rgba(0,0,0,0.1);
}
.ditu_right{
  color: #555;
  font-size: 18px;
  line-height: 2.5em;
  padding: 70px 7%;
  padding-bottom: 0;
  margin-top: 2%;
}
.ditu_right h1{
  margin-bottom: 40px;
}
</style>